import _typeof from "@babel/runtime/helpers/esm/typeof";

var getTimeDecodingFormat = function getTimeDecodingFormat(time) {
  var input = _typeof(time) === 'object' ? time.toDateString() : time.toString();

  if (/^\d{1,2}:\d{2}$/.test(input) || /^\d{2}:\d{2}$/.test(input)) {
    // Hour and minutes in 12 or 24 hour formats, e.g. '11:00' or '23:00'
    return 'HH:mm';
  }

  if (/^\d{1,2}:\d{2} [APMapm]{2}$/.test(input)) {
    // Hour, minutes, and AM/PM, e.g., '11:00 PM'
    return 'h:mm A';
  }

  if (/^\d{1,2} [APMapm]{2}$/.test(input)) {
    // Hour and AM/PM, e.g., '11 PM'
    return 'h A';
  }

  if (/^\d{2}$/.test(input)) {
    // 24-hour format two-digit, e.g., '03'
    return 'HH';
  }

  if (/^\d{1,2}$/.test(input)) {
    // 24-hour format one digit, e.g., '9'
    return 'H';
  } // Default format when not time string is received


  return undefined;
};

export default getTimeDecodingFormat;